<template>
  <!--
    Which field feeds a detail card's leading icon — the web half of the app listing designer's
    "Icon Information" row. Single select over the field types AppListGuard accepts as an icon
    (Image, Images, File, Files, Selection), plus "None" for a card with no leading visual.
  -->
  <fts-dropdown-select ref="dropdown" class="icon-field-dropdown" content-class="icon-field-dropdown-menu"
    :offset="[0, 6]" @show="openDropdown">
    <template #toggle>
      <slot name="toggle" />
    </template>

    <template #menu>
      <div class="fts-form-control-filter">
        <input type="text" class="fts-form-control" v-model="search" placeholder="Search" ref="searchInput" />
        <div class="search-icon">
          <font-awesome-icon :icon="['fas', 'search']" fixed-width />
        </div>
      </div>

      <div class="dropdown-list">
        <div class="dropdown-option" :class="{ 'dropdown-option--active': !selected }" @click="toggleSelect(null)">
          <div>No icon</div>
        </div>
        <div v-for="x in fieldList" :key="x.id" class="dropdown-option"
          :class="{ 'dropdown-option--active': selected === x.id }" @click="toggleSelect(x)">
          <div class="dropdown-option-icon" v-if="x.icon">
            <i :class="x.icon"></i>
          </div>
          <div>{{ x.displayName }}</div>
        </div>
      </div>

      <div class="dropdown-no-results" v-if="!fieldList.length">
        No field on this module can be an icon — add an Image, File or Selection field first.
      </div>

      <div class="button-wrapper">
        <button type="button" class="fts-btn fts-btn-raised fts-btn-primary" @click="confirmSelection">
          <font-awesome-icon :icon="['fas', 'check']" fixed-width />Save
        </button>
      </div>
    </template>
  </fts-dropdown-select>
</template>

<script>
import FTSDropdownSelect from './FTSDropdownSelect';
import commons from '../commons/commons';

export default {
  name: 'IconFieldDropdown',
  components: {
    'fts-dropdown-select': FTSDropdownSelect,
  },
  props: {
    /* Icon-eligible fields only — the caller filters, this list just shows them. */
    informations: { type: Array, default: () => [] },
    initialSelected: String,
  },
  emits: ['select'],
  data() {
    return {
      search: '',
      selected: null,
    };
  },
  computed: {
    fieldList() {
      const query = this.search.toLowerCase();
      return (this.informations || [])
        .map((x) => ({
          id: x.id,
          displayName: x.displayName || x.name || x.fieldName || String(x.id),
          icon: commons.informationIcon(x.type),
        }))
        .filter((x) => x.displayName.toLowerCase().includes(query));
    },
  },
  methods: {
    openDropdown() {
      this.search = '';
      this.selected = this.initialSelected || null;
    },
    toggleSelect(item) {
      this.selected = item ? item.id : null;
    },
    confirmSelection() {
      this.$emit('select', this.selected);
      this.$refs.dropdown.$refs.popper.doClose();
    },
  },
};
</script>

<style lang="scss">
.icon-field-dropdown-menu {
  min-height: 50px;
  padding: 0.5rem;
  background: #fff;
  border: 1px solid #ddd;
  text-align: center;
  color: #aaa;
}
</style>
